export default __webpack_public_path__ + "static/media/Mobile login-pana 1.0d27960e.png";